
const ENDPOINT = process.env.REACT_APP_API_URL;

const formatDate = (date) => date.toISOString().split("T")[0];

export const getReportData = async (fechaInicio, fechaFin, tipoReporte, token) => {
  try {
    const inicio = formatDate(fechaInicio);
    const fin = formatDate(fechaFin);
    const response = await fetch(
      `${ENDPOINT}/reports?fecha_inicio=${inicio}&fecha_fin=${fin}&tipoReporte=${tipoReporte}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Error al obtener los datos del reporte: ${errorText}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error al obtener los datos del reporte:", error);
    return null;
  }
};

export const downloadExcel = async (fechaInicio, fechaFin, tipoReporte, token) => {
  try {
    const inicio = formatDate(fechaInicio);
    const fin = formatDate(fechaFin);
    const response = await fetch(
      `${ENDPOINT}/reports/download?fecha_inicio=${inicio}&fecha_fin=${fin}&tipoReporte=${tipoReporte}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Error al descargar el reporte: ${errorText}`);
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `reporte_${tipoReporte}_${inicio}_${fin}.xlsx`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error al descargar el reporte:", error);
  }
};
